import * as services from '@/services'

export default {
  namespaced: true,

  actions: {
    async OPEN_CHECKOUT({ rootGetters }, plan) {
      try {
        const { content } = await services.payments.liqpayCheckout({
          locale: rootGetters['locale/currentLocale'],
          plan
        })

        // Redirect directly to payment gateway
        window.location.href = content.link
      } catch (e) {
        console.error('Failed to initiate checkout:', e)
        // alert(this.$t('payment.error.somethingWentWrong'))
      }
    }
  }
}
